module.exports = __webpack_public_path__ + "static/media/TRANSITO.fc0f9324.jpg";